import Image from 'next/image';
import { VerifiedIcon } from 'lucide-react';
import gizmodoAvatar from "@assets/images/homepage/tobi.webp";

/* ------------------------------------------------------------------ */
/*  Main component                                                     */
/* ------------------------------------------------------------------ */
const GizmodoReviewCard = () => {
  return (
    <a
      href="https://x.com/tobi/status/1929212116646445169"
      target="_blank"
      rel="noopener noreferrer"
      // className="self-end mx-auto mb-4 transition-transform duration-200 ease-in-out hover:scale-105"
      // className="bg-white shadow-lg rounded-28 mx-auto mb-4 transition-transform duration-200 ease-in-out hover:scale-105"
    >
      <div
      className="shadow-lg rounded-[14px] mx-auto mb-4 transition-transform duration-200 ease-in-out hover:scale-105 border-primary border"
      >{/* Black header bar */}
      <div className="rounded-t-[13px] bg-[#1F2022] px-4 py-2">
        <p className="text-white font-medium text-[12px] text-center font-trimMono">
          CEO, Shopify
        </p>
      </div>

      {/* Tweet-style card */}
      <div className="bg-white shadow-lg rounded-b-[14px] p-4 relative">
        {/* Close/X logo */}
        <span className="absolute top-5 right-5">
<svg width="27" height="25" viewBox="0 0 27 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.502349 0L10.7572 13.792L0.4375 25.0005H2.76008L11.7954 15.1856L19.0977 25.0011H26.9995L16.1669 10.4359L25.7728 0H23.4502L15.1294 9.0379L8.40576 0H0.502349ZM3.9181 1.72077H7.5491L23.5821 23.2798H19.9522L3.9181 1.72077Z" fill="#1F2022"/>
</svg>

        </span>

        <div className="flex">
          <Image src={gizmodoAvatar} alt="Gizmodo avatar" className="size-[36px] max-w-[36px] max-h-[36px] gizmodo-avatar rounded-full shrink-0 mr-4" />

          <div>
            <div className="flex items-center gap-1">
              <p className="font-bold text-[14px] leading-none">Tobi Lutke</p>
              <VerifiedIcon className="size-m mb-[1px] fill-[#1DA1F2] stroke-white align-middle" />
            </div>
            <p className="text-[12px] leading-none text-neutal">@tobi</p>
          </div>
        </div>

        {/* Tweet body */}
        <p className="text-[12px] leading-snug mt-3">
          This thing is just incredible. @maticrobots have made something incredibly delightful here.
        </p>

        {/* Timestamp */}
        <p className="text-[12px] mt-2 text-neutal">
          9:23 AM • Jun 1, 2025
        </p>
      </div>
      </div>
    </a>
  );
};

export default GizmodoReviewCard;